import React from "react";
import ProcurementView from "../ProcurementView";

// New — read-only breakdown of committed demand (N) only. See ProcurementView.jsx.
function ProcurementNewPage() {
    return <ProcurementView view="new" />;
}

export default ProcurementNewPage;
